import React from "react";
import CiudadanosTable from "../components/CiudadanosTable";
import Layout from "../components/Layout";
const Ciudadanos = () => {
  return (
    <>
      <Layout />
      <div>
        <CiudadanosTable />
      </div>
    </>
  );
};

export default Ciudadanos;
